import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Popover } from "react-tiny-popover";
import styles from "./style.module.css";

import useMediaQuery from "../../hooks/useMediaQuery";

const IconButton = ({
  icon,
  onClick,
  customClass,
  link,
  disabled,
  onMouseEnter,
  onMouseLeave,
  isTooltip = false,
  tooltipPosition = ["right"],
  tooltipAlign = "end",
  tooltipContent,
  tooltipTransform = { top: -15, left: 1 },
  tooltipCustomClass = "",
  dataTour = "",
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    if (!isMobile) {
      setOpen(!open);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Popover
      containerClassName={`${styles.tooltipPopover} ${tooltipCustomClass}`}
      isOpen={isTooltip ? open : false}
      positions={tooltipPosition}
      align={tooltipAlign}
      content={<div className={styles.tooltipContent}>{tooltipContent}</div>}
      onClickOutside={handleClose}
      transform={tooltipTransform}
      transformMode="relative"
    >
      <div
        className={styles.icon_button_wrapper}
        onMouseEnter={handleToggle}
        onMouseLeave={handleClose}
      >
        {link ? (
          <Link
            className={`${styles.icon_button} ${customClass}`}
            to={link}
            disabled={disabled}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            data-tour={dataTour}
          >
            {icon}
          </Link>
        ) : (
          <button
            className={`${styles.icon_button} ${customClass}`}
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            type="button"
            data-tour={dataTour}
          >
            {icon}
          </button>
        )}
      </div>
    </Popover>
  );
};

export default IconButton;
